<template>
    <div>
        <Layout>
            <div class="search-main main">
                <section class="recent_course">
                    <Tabs :animated="true" @on-click="tabChange">
                        <TabPane :label="`课程/${totalInfo.moduleNumbers.course||0}`">
                            <div class="class-list">
                                <div class="class-item" v-for="item in classListInfo.results" :key="item.id">
                                    <img :src="item.cover" @click="goDetail(item)"
                                         class="class-cover"/>
                                    <div class="right-info">
                                        <div class="class-title" v-html="item.title" @click="goDetail(item)"></div>
                                        <div class="class-auth" v-html="item.lecturerName"></div>
                                        <div class="class-desc" v-html="item.description"></div>
                                        <Button icon="md-eye" class="file-download" @click="goDetail(item)"> 查看详情
                                        </Button>
                                        <Button icon="md-download" class="file-download"
                                                @click="downloadClassFiles(item)"> 课件下载
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <Empty v-if="!totalInfo.moduleNumbers.course"/>
                        </TabPane>
                    </Tabs>
                </section>
                <Page :total="totalInfo.searchType==='productManual'?totalInfo.moduleNumbers.productManual:totalInfo.moduleNumbers.course"
                      v-if="(totalInfo.searchType==='productManual'?totalInfo.moduleNumbers.productManual:totalInfo.moduleNumbers.course)>0"
                      :current="filterParams.pageIndex"
                      :page-size="filterParams.pageSize"
                      @on-page-size-change="handlePageSizeChange"
                      @on-change="handleChange"/>
            </div>
            <Spin size="large" fix v-if="loading"></Spin>
        </Layout>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Empty from './empty'
    import storage from '@/plugins/storage'
    import api from '@/api/calss-search'
    import course from '@/api/course'
    import file from '@/api/file'
    import sensorHelp from '@/vendor/sensors/help'
    import {SCHOOL_CLASS_SEARCH_VISIT, SCHOOL_CLASS_SEARCH_CLICK} from '@/constant/sensorEvent'
    import {COURSE_STATE} from '@/constant/constants'

    export default {
        components: {Empty},
        computed: {
            ...mapState('app', ['isLogin']),
        },
        data() {
            return {
                token: storage.get('token'),
                total: 100,
                filterParams: {
                    query: this.$router.currentRoute.query.keyword,
                    pageIndex: 1,
                    pageSize: 10,
                    searchType: this.$router.currentRoute.query.searchType || 'course'
                },
                productManualInfo: {},
                classList: [],
                loading: false,
                totalInfo: {courseTotal: 0, productManualTotal: 0, total: 0},
                classListInfo: {},
                COURSE_STATE,
            }
        },
        watch: {
            $route(to, from) {
                this.filterParams.query = this.$router.currentRoute.query.keyword
                this.filterParams.pageIndex = 1
                this.filterParams.pageSize = 10
                this.queryList()
            }
        },
        mounted() {
            // 加载跳转到顶部
            window.scrollTo(0, 0)
            this.init()
            sensorHelp.track(SCHOOL_CLASS_SEARCH_VISIT, {
                school_visit_time_hour: new Date().getHours(),
            })
        },
        methods: {
            tabChange(tab) {
                this.filterParams.searchType = tab ? 'productManual' : 'course'
                this.filterParams.pageIndex = 1
                this.queryList()
            },
            viewPdf(item) {
                const url = window.origin + `/pdf/pdf-viewer/viewer.html?url=${JSON.parse(item.productManualUrl).url}`
                window.open(url)
            },
            init() {
                this.queryList()
            },
            handlePageSizeChange(pageSize) {
                this.filterParams.pageIndex = 1
                this.filterParams.pageSize = pageSize
                this.queryList()
            },
            handleChange(pageIndex) {
                this.filterParams.pageIndex = pageIndex
                this.queryList()
            },
            async downloadClassFiles(item) {
                this.coursesFiles = await file.getCourseFiles({}, {paths: {courseId: item.id}})
                if (!this.coursesFiles.length) {
                    this.$Message.info('暂无附件')
                } else {
                    const course = this.coursesFiles[0]
                    if (course.lockState === 1) { // 加锁状态
                        this.$Message.info(`课件将在开课后${this.course.unlockAttachmentTime}分钟后自动解锁`)
                        return
                    }
                    let domain = process.env.NODE_ENV === 'development' ? this.$config.courseFilesDomain : ''
                    let href = `${domain}/live/api/v1/outer/file/seaFile/download/${item.id}?path=${encodeURIComponent('/')}&fileName=${encodeURIComponent(course.name)}`
                    if (this.token) {
                        href += `&school_token=${this.token}`
                    }
                    if (sessionStorage.getItem('verify-md5')) {
                        href += `&verify-md5=${sessionStorage.getItem('verify-md5')}`
                    }
                    console.log(href,'llll')
                    window.location.href = href
                }
            },
            // 查询数据
            async queryList() {
                this.loading = true
                api.classSearchList(this.filterParams).then(res => {
                    this.loading = false
                    this.totalInfo = res
                    if (res.searchType === 'productManual') {
                        this.productManualInfo = res
                    } else {
                        this.classListInfo = res
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            // 手册附件下载
            async annexDownload(item) {
                let downloadRes = await api.annexDownload({title: item.title, annexUrl: item.annexUrl})
                window.open(downloadRes)
            },
            goDetail(item) {
                if (item.courseType == 1) {
                    this.$router.push('/detail/' + item.id)
                } else {
                    this.$router.push(`/record/detail/${item.id}`)
                }
            },
            handleClick(v, path, bool) {
                if (bool) {
                    sensorHelp.track(SCHOOL_CLASS_SEARCH_CLICK, {
                        position: 'recommend',
                    })
                }
                if (v.enable) {
                    this.$router.push({name: path, params: {courseId: v.pkid || v.id || v.resourceId}})
                } else {
                    if (this.isLogin) {
                        this.$store.commit('app/setDrainagePopVisible', {flag: true, enableSign: v.enableSign})
                    } else {
                        this.$Message.error('请先登录')
                        this.$router.push({name: 'Login'})
                    }
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    .main {
        margin: auto;

        &.search-main {
            margin-top: 24px;
        }

        .search-result-number {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #4a4a4a;
        }

        .recent_course {
            min-width: 960px;
            max-width: 1040px;
            margin: 20px auto;

            /deep/ .ivu-tabs-nav .ivu-tabs-tab-active {
                color: #ED6C00;
            }

            /deep/ .ivu-tabs-nav .ivu-tabs-tab:hover {
                color: #ED6C00;
            }

            /deep/ .ivu-tabs-ink-bar {
                background-color: #ED6C00;
            }

            .class-list {
                .class-item {
                    display: flex;
                    margin-bottom: 24px;
                    .image-container{
                        border-radius: 1.3px;
                        padding: 5px 13px 0px 14px;
                        border: 1.3px solid #eaeaea;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08)
                    }
                    &.product{
                       .class-cover{
                           width: 88px;
                           height: 126.6px;
                           border-radius: 0;
                           border: 1.3px solid #eaeaea;
                           box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08)
                       }
                       .right-info{
                           .file-download{
                               margin-top: 50px;
                           }
                       }
                    }
                    .class-cover {
                        width: 205px;
                        height: 115px;
                        border-radius: 4px;
                        cursor: pointer;
                    }

                    .right-info {
                        padding-left: 20px;
                        .class-title {
                            cursor: pointer;
                            font-size: 16px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.5;
                            letter-spacing: normal;
                            color: #212121;
                        }

                        /deep/ .search-result-highlight {
                            color: #ED6C00 !important;
                        }
                        .class-desc{
                            font-size: 12px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            letter-spacing: normal;
                            color: #666666;
                            height: 34px;
                            max-width: 600px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }
                        .class-auth {
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            letter-spacing: normal;
                            color: #666666;
                            max-width: 600px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }

                        .file-download {
                            width: 99px;
                            margin-top: 10px;
                            height: 28px;
                            margin-right: 10px;
                            border-radius: 2px;
                            border: solid 1px #eeeeee;
                            background-color: #f8f8f9;

                            /deep/ {
                                line-height: 12px;
                                font-size: 12px !important;
                                color: #8590a6;
                            }
                        }
                    }
                }
            }
        }

        /deep/ .ivu-page {
            text-align: center;
        }

        /deep/ .ivu-row {
            min-height: 300px;
        }

        /deep/ .ivu-page-item-active {
            border-color: #ED6C00;

            a {
                color: #ED6C00;
            }
        }

        /deep/ .ivu-page-item {
            &:hover {
                border-color: #ED6C00;

                a {
                    color: #ED6C00;
                }
            }
        }

        /deep/ .ivu-page-prev, /deep/ .ivu-page-next {
            &:not(.ivu-page-disabled) {
                &:hover {
                    border-color: #ED6C00;

                    a {
                        color: #ED6C00;
                    }
                }
            }
        }

        /deep/ .ivu-spin-dot {
            background-color: #ED6C00;
        }
    }
</style>
